import React from 'react';
import { Footer as FooterComponent } from '@views/components/app/Document';
import { companyInfo, supportLinks, policyLinks } from '@mocks/sample-data';
import CategoryMenu from './category';

export const Footer = () => {
  return (
    <>
      <FooterComponent
        companyInfo={companyInfo}
        supportLinks={supportLinks}
        policyLinks={policyLinks}
      />
      <CategoryMenu />
    </>
  );
};

export default Footer;
